(() => {
  'use strict';
  function bind(element, key, callback) {
    if (element.dataset[key]) return;
    element.dataset[key] = 'true'; callback(element);
  }
  function init(scope = document) {
    scope.querySelectorAll('.reveal-on-scroll').forEach(element => bind(element, 'revealReady', () => {
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {element.classList.add('is-visible'); return;}
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {entry.target.classList.add('is-visible'); observer.unobserve(entry.target);}
      }), {threshold: 0.05}); observer.observe(element);
    }));
    scope.querySelectorAll('[data-facets-form]').forEach(form => bind(form, 'facetsReady', () => {
      form.querySelectorAll('[data-facet-select]').forEach(select => select.addEventListener('change', () => form.requestSubmit()));
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[name], select[name]').forEach(input => {if (input.value === '') input.disabled = true;});
      });
    }));
    scope.querySelectorAll('[data-gallery]').forEach(gallery => bind(gallery, 'galleryReady', () => {
      const main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-gallery-image]').forEach(image => {image.classList.toggle('is-active', image.dataset.galleryImage === thumb.dataset.galleryThumb); image.style.transform = '';});
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(button => {button.classList.toggle('is-active', button === thumb); button.setAttribute('aria-pressed', String(button === thumb));});
      }));
      if (!main) return;
      main.addEventListener('mousemove', event => {
        if (!matchMedia('(hover: hover)').matches) return;
        const image = main.querySelector('.is-active'); if (!image) return;
        const rect = main.getBoundingClientRect(); image.style.transformOrigin = `${(event.clientX - rect.left) / rect.width * 100}% ${(event.clientY - rect.top) / rect.height * 100}%`;
      });
      main.addEventListener('mouseenter', () => {if (matchMedia('(hover: hover)').matches) {const image = main.querySelector('.is-active'); if (image) image.style.transform = 'scale(1.6)';}});
      main.addEventListener('mouseleave', () => {const image = main.querySelector('.is-active'); if (image) image.style.transform = '';});
    }));
    scope.querySelectorAll('#product-form').forEach(form => bind(form, 'productReady', () => {
      const stateElement = document.querySelector('[data-product-state]');
      if (!stateElement) return;
      const product = JSON.parse(stateElement.textContent);
      const input = form.querySelector('[data-variant-id-input]');
      const groups = [...form.querySelectorAll('[data-option-index]')];
      const qtyInput = form.querySelector('[data-qty-input]');
      let current = product.variants.find(variant => String(variant.id) === input.value);
      const buttons = () => [...document.querySelectorAll('[data-add-to-cart], [data-mobile-buy-bar] button')];
      function setQuantity(value) {
        const minimum = current?.minimum || 1, increment = current?.increment || 1;
        let maximum = current?.maximum || 999999;
        if (current?.inventory !== null && current?.inventory !== undefined) maximum = Math.min(maximum, current.inventory);
        value = Math.max(minimum, Math.min(maximum, value));
        value = minimum + Math.max(0, Math.floor((value - minimum) / increment)) * increment;
        qtyInput.value = value; form.querySelector('[data-qty-value]').textContent = value;
      }
      function sync(updateURL = false) {
        const selected = groups.map(group => group.querySelector('.is-selected')?.dataset.optionValue);
        current = groups.length ? product.variants.find(variant => selected.every((value, i) => variant.options[i] === value)) : product.variants.find(variant => String(variant.id) === input.value);
        input.value = current?.id || '';
        const available = Boolean(current?.available);
        buttons().forEach(button => {button.disabled = !available || form.dataset.busy === 'true'; button.textContent = !current ? 'Unavailable' : available ? 'Add to Cart' : 'Out of Stock';});
        document.querySelectorAll('.product-info__price-current, .mobile-buy-bar__price').forEach(element => {element.textContent = current?.price || '';});
        const compare = document.querySelector('.product-info__price-compare');
        if (compare) {compare.textContent = current?.compare || ''; compare.hidden = !current?.compare;}
        const stock = form.querySelector('[data-low-stock]');
        if (stock) {stock.hidden = !(current?.inventory > 0 && current.inventory <= 5); if (!stock.hidden) stock.textContent = `Only ${current.inventory} left in stock — order soon.`;}
        if (current) setQuantity(Number(qtyInput.value));
        const image = current?.image && document.querySelector(`[data-image-id="${current.image}"]`);
        if (image) document.querySelector(`[data-gallery-thumb="${image.dataset.galleryImage}"]`)?.click();
        if (updateURL) {const url = new URL(location.href); if (current) url.searchParams.set('variant', current.id); else url.searchParams.delete('variant'); history.replaceState({}, '', url);}
      }
      groups.forEach(group => group.querySelectorAll('[data-option-value]').forEach(pill => pill.addEventListener('click', () => {
        group.querySelectorAll('[data-option-value]').forEach(button => {button.classList.toggle('is-selected', button === pill); button.setAttribute('aria-pressed', String(button === pill));}); sync(true);
      })));
      form.querySelector('[data-qty-decrease]')?.addEventListener('click', () => setQuantity(Number(qtyInput.value) - (current?.increment || 1)));
      form.querySelector('[data-qty-increase]')?.addEventListener('click', () => setQuantity(Number(qtyInput.value) + (current?.increment || 1)));
      form.addEventListener('craftline:purchase-complete', () => sync());
      sync();
    }));
  }
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-menu-open]');
    if (opener) window.CraftlineDialog.open(document.querySelector('[data-mobile-menu]'), document.querySelector('[data-menu-overlay]'), opener);
    if (event.target.closest('[data-menu-close], [data-menu-overlay], [data-mobile-menu] a')) window.CraftlineDialog.close();
    const quickAdd = event.target.closest('[data-quick-add]');
    if (!quickAdd || quickAdd.disabled) return;
    event.preventDefault(); quickAdd.disabled = true;
    const label = quickAdd.querySelector('[data-quick-add-label]'), original = label?.textContent;
    try {await window.CraftlineCart.addItem(quickAdd.dataset.variantId, 1, quickAdd); if (label) label.textContent = 'Added';}
    catch (error) {
      let message = quickAdd.closest('.product-card').querySelector('[role="alert"]');
      if (!message) {message = document.createElement('p'); message.setAttribute('role', 'alert'); quickAdd.closest('.product-card').append(message);}
      message.textContent = error.message;
    } finally {quickAdd.disabled = false; if (label) setTimeout(() => {label.textContent = original;}, 1600);}
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
